import { useState } from "react";
import { BotIcon } from "./Icons";

export function ChatAvatar({ chatAvatarUrl }: { chatAvatarUrl: string }) {
  const [imageFailed, setImageFailed] = useState(false);
  const showCompanyImage = Boolean(chatAvatarUrl) && !imageFailed;

  return (
    <div className={`avatar bot-avatar${showCompanyImage ? " company-avatar" : ""}`}>
      {showCompanyImage ? (
        <img
          src={chatAvatarUrl}
          alt=""
          aria-hidden="true"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <BotIcon />
      )}
    </div>
  );
}
